import React, { useEffect, useState } from 'react';

import styles from './index.module.scss';

interface ButtonProps {
  children?: React.ReactNode;
  onClick?: () => void;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  disabled?: boolean | false;
  loading?: boolean | false;
  color?: 'primary' | 'secondary' | 'primary-light' | 'black' | 'white';
  onlyIcon?: string;
  gmalite?: boolean;
  borderRadius?: string;
  size?: 'small' | 'medium' | 'large';
}

const Button: React.FC<ButtonProps> = ({ onClick, children, href, type, disabled, loading, color, onlyIcon, borderRadius, size }) => {
  if (href) {
    return (
      <a href={href} className={styles.button + (onlyIcon ? ' btn-icon' : '') + (color ? ' btn-' + color : ' btn-primary') + (loading ? ' ' + styles.loading : '' + (borderRadius ? ' border-radius-' + borderRadius : ''))}>
        {onlyIcon ? <i className={'icon-' + onlyIcon} /> : children}
      </a>
    );
  }
  
  return (
    <button  onClick={onClick} className={styles.button +
      (onlyIcon ? ' btn-icon' : '') +
      (color ? ' btn-' + color : ' btn-primary') +
      (loading ? ' ' + styles.loading : '') +
      (borderRadius ? ' border-radius-' + borderRadius : '') +
      (size ? ' btn-' + size : '')} type={type} disabled={disabled}>
      {onlyIcon ? <i className={'icon-' + onlyIcon} /> : children}
    </button>
  );
};

export default Button; 